import { $host } from '@/http'

const userFilterTradeOfferUrl = '/trade-offer/showcase/filter-users'
export const userFilterApi = {
  getTradeOfferCompaniesAndOrganizers: async (params = {}) => {
    const { data } = await $host.get(userFilterTradeOfferUrl, { params })
    return data
  },
}
